import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { useSelector } from 'src/store';
import { rolesApp } from 'src/utils/rolesConstants';
import { validateRoles } from 'src/utils/validateRoles';


const allowedRoles = [rolesApp.SUPERADMIN, rolesApp.PRODUCTOR];
const RouteRedirect = () => {
  const { roles } = useSelector((state) => state.auth);
 
  if (roles && validateRoles(roles, allowedRoles)) {
    return <Navigate to="dashboard/management/home" replace />;
  }
  return <Status404 />;
};

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Status404 = Loader(lazy(() => import('src/content/pages/Status/Status404')));
const Status500 = Loader(lazy(() => import('src/content/pages/Status/Status500')));
const StatusComingSoon = Loader(lazy(() => import('src/content/pages/Status/ComingSoon')));
const StatusMaintenance = Loader(lazy(() => import('src/content/pages/Status/Maintenance')));
// const Status401 =  Loader(lazy(() => import('src/content/pages/Status/Status401')));

const baseRoutes = [
  {
    path: '/',
    element: <Navigate to="/account/login" replace />
  },
  {
    path: 'status',
    children: [
      // {
      //   path: 'unauthorized',
      //   element: <Status401 />
      // },
      {
        path: '500',
        element: <Status500 />
      },
      {
        path: 'maintenance',
        element: <StatusMaintenance />
      },
      {
        path: 'coming-soon',
        element: <StatusComingSoon />
      }, 
    ]
  },
  {
    path: '*',
    element: <RouteRedirect />
  }
];

export default baseRoutes;
